import { execOnLoad } from '@general/helpers';
import './localization-selector.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initLocalizationSelector = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const countrySwitcherSelector = sectionContainer.querySelector(
    '.localization-selector__country',
  );
  const languageSwitcherSelector = sectionContainer.querySelector(
    '.localization-selector__language',
  );
  const countrySwitcherSelectorOpener = sectionContainer.querySelector(
    '.localization-selector__country__selected',
  );
  const languageSwitcherSelectorOpener = sectionContainer.querySelector(
    '.localization-selector__language__selected',
  );

  if (countrySwitcherSelector && countrySwitcherSelectorOpener) {
    countrySwitcherSelectorOpener.addEventListener('click', function () {
      if (countrySwitcherSelector.classList.contains('open')) {
        countrySwitcherSelector.classList.remove('open');
      } else {
        countrySwitcherSelector.classList.add('open');
      }

      if (
        languageSwitcherSelector &&
        languageSwitcherSelector.classList.contains('open')
      ) {
        languageSwitcherSelector.classList.remove('open');
      }
    });
  }

  if (languageSwitcherSelector && languageSwitcherSelectorOpener) {
    languageSwitcherSelectorOpener.addEventListener('click', function () {
      if (languageSwitcherSelector.classList.contains('open')) {
        languageSwitcherSelector.classList.remove('open');
      } else {
        languageSwitcherSelector.classList.add('open');
      }

      if (
        countrySwitcherSelector &&
        countrySwitcherSelector.classList.contains('open')
      ) {
        countrySwitcherSelector.classList.remove('open');
      }
    });
  }
};

execOnLoad(
  window.dAgency.initLocalizationSelector,
  '.localization-selector__section',
);
